module.exports = __webpack_public_path__ + "img/scanning-slips.9b200713.svg";